module.exports = __webpack_public_path__ + "img/q_hand_v.dbd1da98.gif";